import { useState, useRef } from "react";
import Tilt from "react-parallax-tilt";
import { motion, AnimatePresence } from "framer-motion";
import clsx from "clsx";
import { ChevronLeft, ChevronRight } from "lucide-react";
import {
  buildingPropertyLoan,
  carLoan,
  commercialBuilding,
  commercialVehicle,
  existingHomeLoan,
  homeExtension,
  homeRenovation,
  housePurchase,
  landLoan,
  lifeInsurance,
  NRIHomeLoan,
  plotPurchase,
  selfEmployee,
  solarLoan,
  twoWheelerLoan,
  unSecuredBusinessLoan,
  mortgageLoan,
  educationalLoan,
  newCommercialVehicleLoan,
  tractorLoan,
  residentialPropertyLoan,
  personalLoanSalaried,
  newTwoWheelerLoan,
  newCarLoan,
  generalInsurance,
  doctorLoan,
  constructionLoanIcon,
} from "../assets/Images";

// cSpell: Ignore Subramaniam homeownership MBBS disbursals

const loanSections1 = [
  {
    heading: "Home Loans",
    // subHeading: `At Subramaniam Financial Services, we understand that a home is more than just a building. It's a lifelong dream. Our range of home loan solutions is designed to support you at every stage of your journey, whether you're building from scratch, buying a ready-made property, or upgrading your existing home. With expert guidance, competitive interest rates, and a seamless application process, we make homeownership simple and stress-free.`,
    loans: [
      {
        title: "Construction Loans",
        description: `At Subramaniam Financial Services, we understand that a home is more than just a building. It's a lifelong dream. Our range of home loan solutions is designed to support you at every stage of your journey, whether you're building from scratch, buying a ready-made property, or upgrading your existing home.`,
        icon: constructionLoanIcon,
        isTrending: false,
      },
      {
        title: "Plot Purchase with Construction",
        description: `Looking to purchase land and build your home on it? Our combined loan offering helps you finance both the plot purchase and the construction. This integrated solution simplifies your loan process and provides timely disbursement for each stage of your plan, from acquiring the plot to completing the building.`,
        icon: plotPurchase,
        isTrending: false,
      },
      {
        title: "New & Old House Purchase",
        description: `Whether you're buying a newly constructed home or a pre-owned property, we offer flexible loan options with quick approvals and competitive rates. Our team assists you through the legal verification, documentation, and financing steps, making your home buying experience smooth and efficient.`,
        icon: housePurchase,
      },
      {
        title: "Commercial Building Property Purchase",
        description: `If you're planning to invest in commercial real estate, such as offices, shops, or warehouses, we provide tailored financing options to support your goals. Our commercial property loans are ideal for business owners and investors who want to grow their assets or expand their operations.`,
        icon: buildingPropertyLoan,
      },
      {
        title: "Home Extension Loans",
        description: `Need more space for your growing family or lifestyle needs? Our home extension loans are designed for those looking to expand their existing structure — whether it's adding a new floor, a room, or extending the living area. With easy approvals and transparent processes, upgrading your home is now within reach.`,
        icon: homeExtension,
      },
      {
        title: "Home Renovation Loans",
        description: `Give your home a fresh new look with our renovation loans. Whether it's remodeling your kitchen, upgrading your bathrooms, painting interiors, or modernizing the electrical and plumbing systems, we provide financing that covers all types of renovation projects — large or small.`,
        icon: homeRenovation,
      },
      {
        title: "Balance Transfer & Top-Up Loans",
        description: `Already repaying a home loan elsewhere? Transfer your loan to us and enjoy lower interest rates and reduced EMIs. Additionally, you can avail a top-up loan for personal use — such as furnishing your home, covering educational expenses, or handling unexpected costs — all with a single, streamlined process.`,
        icon: existingHomeLoan,
      },
      {
        title: "NRI Home Loans",
        description: `For our Non-Resident Indian clients, we offer customized home loan solutions to help you invest in property back home. Whether you're purchasing, constructing, or renovating, our NRI home loans are structured to comply with Indian regulations while ensuring convenience and clarity every step of the way.`,
        icon: NRIHomeLoan,
      },
    ],
  },
  {
    heading: "Vehicle Loan",
    // subHeading: `Subramaniam Financial Services offers a comprehensive range of vehicle financing solutions designed to meet both personal and business needs. Whether you're planning to buy a new vehicle or upgrade an existing one, we provide flexible and affordable loan options to support your journey.`,
    loans: [
      {
        title: "New Two-Wheeler Loans",
        description: `For those looking to purchase a brand-new bike or scooter, our New Two-Wheeler Loans come with easy EMIs, quick approvals, and minimal documentation. It's an ideal option for first-time buyers and everyday commuters.`,
        icon: newTwoWheelerLoan,
      },
      {
        title: "Used Two-Wheeler Loans",
        description: `Our Used Two-Wheeler Loans offer affordable financing for pre-owned vehicles, featuring low down payments, flexible repayment terms, and hassle-free processing. It's the perfect solution for cost-conscious riders seeking convenience.`,
        icon: twoWheelerLoan,
      },
      {
        title: "New Car Loans",
        description: `With our New Car Loans, you can drive home your dream car with low interest rates and flexible tenures. The loan process is fast and simple, making it accessible for both salaried and self-employed individuals.`,
        icon: newCarLoan,
      },
      {
        title: "Used Car Loans",
        description: `For those considering a certified used car, our Pre-Owned Car Loans provide trusted financing options with quick disbursals and budget-friendly EMIs. We work with verified dealers to ensure a safe and reliable purchase.`,
        icon: carLoan,
      },
      {
        title: "New commercial vehicle loans",
        description: `Our Commercial Vehicle Loans cover both new and used vehicles such as trucks, vans, and more. Whether you're starting a transport business or expanding your fleet, we offer customized loan solutions to suit your business goals. Competitive interest rates and speedy approvals help keep your operations running smoothly.`,
        icon: commercialVehicle,
      },
      {
        title: "Used Commercial Vehicle Loans",
        description: `At Subramaniam Financial Services, we offer specialized loan solutions for used commercial vehicles such as trucks, vans, and other transport vehicles. Our financing options are designed to help business owners expand or upgrade their fleet without straining their working capital. With minimal documentation, quick approvals, and flexible repayment terms, we make it easy for you to invest in reliable pre-owned vehicles that support your operational needs.`,
        icon: newCommercialVehicleLoan,
      },
      {
        title: "Tractor Loans",
        description: `At Subramaniam Financial Services, we offer specialized loan solutions for used commercial vehicles such as trucks, vans, and other transport vehicles. Our financing options are designed to help business owners expand or upgrade their fleet without straining their working capital. With minimal documentation, quick approvals, and flexible repayment terms, we make it easy for you to invest in reliable pre-owned vehicles that support your operational needs.`,
        icon: tractorLoan,
      },
    ],
  },
];
const loanSections2 = [
  {
    heading: "Loan Against Property",
    // subHeading: `A Loan Against Property is a type of secured loan where you mortgage your owned property residential, commercial or industrial  to a bank or financial institution in exchange for funds. The property remains as collateral until the loan is fully repaid.`,
    loans: [
      {
        title: "Residential Property Loans",
        description: `Residential Property Loans provide the ideal financial support to purchase, construct, or renovate your dream home. With funding of up to of the property’s value and interest rates starting from.These loans offer flexible repayment terms of up to 30 years. Available for both salaried and self employed individuals aged 21 to 65, the process is smooth with minimal documentation. Borrowers can also enjoy tax benefits under Sections 80C and 24(b) of the Income Tax Act. Secure your future with a hassle free home loan solution tailored to your needs.`,
        icon: residentialPropertyLoan,
      },
      {
        title: "Commercial Building Property Loans",
        description: `Commercial Building Property Loans offer tailored financial solutions for purchasing, constructing, or renovating commercial spaces such as offices, shops, warehouses, or industrial units. These secured loans provide high-value funding with competitive interest rates and flexible repayment tenures of up to 20 years. Suitable for business owners, entrepreneurs and self-employed professionals, the loan requires valid business proof, property documents, and a healthy credit profile. Funding is typically up to the property's market value. Empower your business growth with a smart investment in commercial infrastructure.`,
        icon: commercialBuilding,
      },
      {
        title: "Existing Mortgage Loan Balance Transfer and Top Up Loans",
        description: `Looking to reduce your EMI burden or need extra funds for personal or business needs? With our Mortgage Loan Balance Transfer, you can shift your existing home loan to us at a lower interest rate, saving significantly over time. Alongside, avail a TopUp Loan on your existing mortgage for added financial flexibility be it for home renovation, medical emergencies, education or business expansion. Enjoy faster processing, minimal documentation and attractive interest rates tailored to your financial goals.`,
        icon: mortgageLoan,
      },
    ],
  },
];
const loanSections3 = [
  {
    heading: "Personal loan",
    // subHeading: 'Residential and Commercial loan options with balance transfer and TopUp facility.',
    loans: [
      {
        title: "Loans for Salaried",
        description: `Designed specifically for working professionals, our salaried personal loans offer quick approval and fixed EMIs with no collateral required. Whether you're planning a family event or facing an emergency, we help you manage your expenses effortlessly. Simple documentation and transparent terms make the borrowing experience smooth and stress-free.`,
        icon: personalLoanSalaried,
      },
      {
        title: "Loans for Self-Employed",
        description: `We understand the unique financial needs of business owners and freelancers. Our personal loans for self-employed individuals offer flexible repayment options, minimal paperwork, and fast disbursal. Whether you're expanding your business or covering unexpected costs, our loan solutions help you maintain financial stability without delays.`,
        icon: selfEmployee,
      },
    ],
  },
  {
    heading: "Insurance",
    // subHeading: 'Residential and Commercial loan options with balance transfer and TopUp facility.',
    loans: [
      {
        title: "Life Insurance",
        description: `Secure your family’s future with our trusted Life Insurance plans. Whether it’s term insurance, whole life, or endowment policies, we offer tailored solutions to ensure financial protection, peace of mind, and long-term savings for your loved ones in the event of any uncertainties.`,
        icon: lifeInsurance,
      },
      {
        title: "General Insurance",
        description: `Protect what matters most with our wide range of General Insurance services including health, motor, home, and travel insurance. Get comprehensive coverage, quick claim support, and affordable premiums designed to safeguard your lifestyle and assets against unexpected risks.`,
        icon: generalInsurance,
      },
    ],
  },
];
const loanSections4 = [
  {
    heading: "Vacant Land Loan",
    // subHeading: 'Residential and Commercial loan options with balance transfer and TopUp facility.',
    loans: [
      {
        title: "Residential Vacant Land Loan",
        description: `Looking to build your dream home from the ground up? Our Residential Vacant Land Loan helps you purchase approved plots in prime locations with flexible repayment options. Get up to 80% financing and expert support throughout your land-buying journey.`,
        icon: landLoan,
      },
    ],
  },
  {
    heading: "Education Loans",
    // subHeading: 'A solar loan is a loan that helps you finance the purchase and installation of solar panels with flexible monthly payments.',
    loans: [
      {
        title: "Affordable Education Loans",
        description: `Subramaniam Financial Services offers Affordable Education Loans to help students pursue their academic dreams without financial stress. Our loans cover tuition fees, living expenses, travel, and more whether you're studying in India or abroad. With competitive interest rates, flexible repayment options, and minimal paperwork, we ensure a smooth loan process. We are committed to making quality education accessible for every deserving student. Begin your educational journey with confidence, backed by the trusted support of Subramaniam Financial Services.`,
        icon: educationalLoan,
      },
    ],
  },
  {
    heading: "Solar loan",
    // subHeading: 'A solar loan is a loan that helps you finance the purchase and installation of solar panels with flexible monthly payments.',
    loans: [
      {
        title: "Easy Solar loan",
        description: `Switch to clean energy effortlessly with our Easy Solar Loans. Get up to 100% financing, low interest rates, and flexible EMIs.Ideal for homes and businesses looking to save on electricity bills.`,
        icon: solarLoan,
      },
    ],
  },
  {
    heading: "Doctors Loans",
    // subHeading: 'A solar loan is a loan that helps you finance the purchase and installation of solar panels with flexible monthly payments.',
    loans: [
      {
        title: "Doctors Loans",
        description: `A Doctor Loan is a special loan designed exclusively for medical professionals like MBBS, BDS, MD, and other registered doctors. It helps them meet personal, professional, or business needs such as setting up a clinic, buying medical equipment, renovating a hospital, or even buying a home.`,
        icon: doctorLoan,
      },
    ],
  },
  {
    heading: "Unsecured Business",
    // subHeading: 'Residential and Commercial loan options with balance transfer and TopUp facility.',
    loans: [
      {
        title: "Unsecured Business Loans – Collateral-Free",
        description: `At Subramaniam Financial Services, we offer collateral-free unsecured business loans designed to support your business growth without the need for asset security. Whether you need funds for working capital, inventory, expansion, or operational expenses, our loan solutions are tailored for small and medium enterprises. With minimal documentation, flexible repayment terms, and fast approvals, you can access the capital you need to run and grow your business smoothly.`,
        icon: unSecuredBusinessLoan,
      },
    ],
  },
];

const LoanCard = ({ title, description, icon, isTrending }) => {
  const [expanded, setExpanded] = useState(false);
  const shortDesc = description.slice(0, 80);
  const isLong = description.length > 80;

  return (
    <Tilt
      tiltMaxAngleX={10}
      tiltMaxAngleY={10}
      perspective={1000}
      scale={1.03}
      glareEnable={true}
      glareMaxOpacity={0.12}
      transitionSpeed={2000}
      className="w-full h-full"
    >
      <motion.div
        layout
        whileHover={{ boxShadow: "0 10px 30px rgba(0,0,0,0.15)" }}
        className={clsx(
          "relative bg-white rounded-md p-6 transition-all duration-300 cursor-pointer flex flex-col justify-between h-full md:min-h-[18rem]",
          "border border-transparent hover:border-blue-400 hover:shadow-xl group"
        )}
        onClick={() => isLong && setExpanded(!expanded)}
      >
        {isTrending && (
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 300 }}
            className="absolute top-2 right-2 bg-gradient-to-r from-pink-500 to-yellow-400 text-white text-xs px-3 py-1 rounded-full shadow"
          >
            🔥 Trending
          </motion.div>
        )}

        <div className="flex flex-col items-start">
          <div className="w-12 h-12 sm:w-16 sm:h-16 mb-2">
            <img
              src={icon || "https://via.placeholder.com/60"}
              alt={title}
              className="w-full h-full object-contain z-10"
            />
          </div>

          <h3 className="text-lg sm:text-xl font-semibold mb-2">{title}</h3>

          <AnimatePresence initial={false}>
            <motion.div
              key={expanded ? "expanded" : "collapsed"}
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.4 }}
            >
              <p className="text-base text-gray-600">
                {expanded || !isLong ? description : `${shortDesc}...`}
              </p>
            </motion.div>
          </AnimatePresence>

          {isLong && (
            <div className="mt-2 text-center">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setExpanded(!expanded);
                }}
                className="text-blue-600 text-xs hover:underline"
              >
                {expanded ? "Read less" : "Read more"}
              </button>
            </div>
          )}
        </div>
      </motion.div>
    </Tilt>
  );
};


const LoanSection = ({
  heading,
  // subHeading,
  loans,
  gridCols = "sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
}) => {
  return (
    <div className="py-4 px-4">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-4">
        {heading}
      </h2>
      {/* {subHeading && (
        <p className="text-center text-gray-500 max-w-2xl mx-auto mb-4">{subHeading}</p>
      )} */}
      
      <div
        className={`flex overflow-x-auto scrollbar-hide sm:overflow-visible sm:grid gap-4 ${gridCols} items-stretch`}
      >
        {loans.map((loan, index) => (
          <div key={index} className="flex-shrink-0 w-[90%] sm:w-auto">
            <LoanCard
              title={loan.title}
              description={loan.description}
              icon={loan.icon}
              isTrending={loan.isTrending}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const LoanDetails = () => {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    const { scrollLeft, clientWidth } = scrollRef.current;
    scrollRef.current.scrollTo({
      left:
        dir === "left" ? scrollLeft - clientWidth : scrollLeft + clientWidth,
      behavior: "smooth",
    });
  };
  return (
    <div className="min-h-screen text-gray-900 container mx-auto overflow-hidden" id="loan" >
      {/* Section 1 – Grid layout (4 per row) */}
      {loanSections1.map((section, index) => (
        <LoanSection
          key={index}
          heading={section.heading}
          // subHeading={section.subHeading}
          loans={section.loans}
          gridCols="grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4"
        />
      ))}

      {/* Section 2 – 3 per row */}
      {loanSections2.map((section, index) => (
        <LoanSection
          key={`section2-${index}`}
          heading={section.heading}
          // subHeading={section.subHeading}
          loans={section.loans}
          gridCols="grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
        />
      ))}

      {/* Section 3 – each loan group separately under heading */}
      <div className="py-4">
        <div className="grid grid-cols-1 xl:grid-cols-2">
          {loanSections3.map((section, index) => (
            <div key={`section3-${index}`} className="mb-8 px-4">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center">
                {section.heading}
              </h2>
              {/* {section.subHeading && (
                <p className="text-center text-gray-500 max-w-2xl mx-auto mb-4">{section.subHeading}</p>
              )} */}
              <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2">
                {section.loans.map((loan, loanIdx) => (
                  <LoanCard
                    key={`section3-card-${loanIdx}`}
                    title={loan.title}
                    description={loan.description}
                    icon={loan.icon}
                    isTrending={loan.isTrending}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Section 4  */}
      {/* <div className="py-6">
        <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-4">

          {loanSections4.map((section, index) => (
            <div key={`section4-${index}`} className="mb-8 px-4">
              <h2 className="text-2xl font-bold mb-4 text-center">{section.heading}</h2>
              {section.subHeading && (
                <p className="text-center text-gray-500 max-w-2xl mx-auto mb-4">{section.subHeading}</p>
              )}
              <div className="">
                {section.loans.map((loan, loanIdx) => (
                  <LoanCard
                    key={`section4-card-${loanIdx}`}
                    title={loan.title}
                    description={loan.description}
                    icon={loan.icon}
                    isTrending={loan.isTrending}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div className="py-4">
        {/* ✅ Mobile View: stacked vertically */}
        <div className="sm:hidden">
          {loanSections4.map((section, index) => (
            <div key={`mobile-${index}`} className="mb-8 px-4">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center">
                {section.heading}
              </h2>
              {/* {section.subHeading && (
                <p className="text-center text-gray-500 max-w-2xl mx-auto mb-4">{section.subHeading}</p>
              )} */}
              <div className="grid gap-6 grid-cols-1">
                {section.loans.map((loan, loanIdx) => (
                  <LoanCard
                    key={`mobile-card-${loanIdx}`}
                    title={loan.title}
                    description={loan.description}
                    icon={loan.icon}
                    isTrending={loan.isTrending}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* ✅ Desktop/Tablet View: Horizontal scroll with arrows */}
        <div className="hidden sm:block relative overflow-hidden">
          <button
            onClick={() => scroll("left")}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 z-20 bg-white shadow-md hover:bg-blue-100 text-gray-700 rounded-full p-2"
          >
            <ChevronLeft />
          </button>

          <button
            onClick={() => scroll("right")}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 z-20 bg-white shadow-md hover:bg-blue-100 text-gray-700 rounded-full p-2"
          >
            <ChevronRight />
          </button>

          <div
            ref={scrollRef}
            className="flex overflow-x-auto gap-6 scrollbar-hide px-6 py-2"
          >
            {loanSections4.map((section, index) => (
              <div
                key={`desktop-${index}`}
                className="min-w-[320px] max-w-[400px] flex-shrink-0 p-4"
              >
                <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center">
                  {section.heading}
                </h2>
                {/* {section.subHeading && (
                  <p className="text-gray-500 text-sm mb-4 text-center">{section.subHeading}</p>
                )} */}
                <div className="flex flex-col gap-4">
                  {section.loans.map((loan, loanIdx) => (
                    <LoanCard
                      key={`desktop-card-${loanIdx}`}
                      title={loan.title}
                      description={loan.description}
                      icon={loan.icon}
                      isTrending={loan.isTrending}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanDetails;
